module.exports = __webpack_public_path__ + "static/screenshot_mobile_1-80f66e3bd9980e6e98a12e8b4a8d18f0.svg";